import React from 'react';
import { EditUserView } from 'components/edit-view/edit-user';

export default ({userId}) => {
	return (
		<EditUserView userId={userId} />
	)
}
